// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609030634/js/" + chunkId + "." + {"44":"ed757391","225":"ac231901","481":"5d5a7f1a","486":"77607d1a","770":"10195ced"}[chunkId] + ".0.23669652155351684.chunk.js";
};